import {
  CollectionActions,
  CollectionStateSlice,
  mergeDocuments,
  transformIntoDocuments,
} from '@freelancer/datastore/core';
import { transformPool } from './pools.transformers';
import { PoolsCollection } from './pools.types';

export function poolsReducer(
  state: CollectionStateSlice<PoolsCollection> = {},
  action: CollectionActions<PoolsCollection>,
) {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === 'pools') {
        const { result, ref, order } = action.payload;
        return mergeDocuments<PoolsCollection>(
          state,
          transformIntoDocuments(result.pool_models, transformPool),
          order,
          ref,
        );
      }
      return state;
    }
    default:
      return state;
  }
}
